import { ActionIcon, Button, Modal, Tooltip } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import { useMemo, useState } from "react";
import AnswerSender from "../../../../answers/AnswerSender";
import { getProspectBio } from "../../../../../utils";
import { IconEmail } from "../../../../../../../../assets/icons/IconEmail";
import { useLanguage } from "../../../../../../../../stores/LanguageStore";
import AnswerSenderMobile from "../../../mobile/AnswerSenderMobile";

const EmailSenderModal = ({ isIcon, current, onSent, disabled, isMobile }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const about = useMemo(() => {
    const aboutList = [
      { key: "%last_name%", value: "lastName" },
      { key: "%first_name%", value: "firstName" },
      { key: "%job_title%", value: "jobTitle" },
      { key: "%company%", value: "company" },
      { key: "%phone%", value: "phone" },
      { key: "%contact_image_url%", value: "contact_image_url" },
      { key: "%linkedin_url%", value: "linkedin_url" },
      { key: "%email%", value: "email" },
    ];
    let result = {};

    aboutList.forEach((item) => {
      result[item.value] = current?.properties?.find(
        (x) => x.identifier_placeholder === item.key
      )?.value;
    });

    return result;
  }, [current?.properties]);

  return (
    <>
      {isIcon ? (
        <Tooltip label={lang.leads.send_email}>
          <ActionIcon
            variant="light"
            size={isMobile ? "lg" : "md"}
            onClick={handleOpen}
            disabled={disabled}
          >
            <IconEmail size={isMobile ? 18 : 16} />
          </ActionIcon>
        </Tooltip>
      ) : (
        <Button
          onClick={handleOpen}
          leftSection={<IconEmail size={18} />}
          size="md"
          mr={8}
          disabled={disabled}
        >
          {lang.leads.start_email_conversation}
        </Button>
      )}

      {isMobile && opened ? (
        <AnswerSenderMobile
          prospect={current}
          about={getProspectBio(current)}
          setAnswering={setOpened}
          setProspectLoading={onSent}
          alreadyOpened
          onClose={handleClose}
          title={
            <>
              {lang.leads.start_email_conversation} {lang.prm.status.with}:{" "} <br />
              <b>
                {about?.firstName || " - "} {about.lastName || " - "} ({" "}
                {about?.email} )
              </b>
            </>
          }
        />
      ) : (
        <Modal
          opened={opened}
          onClose={handleClose}
          title={
            <>
              {lang.leads.start_email_conversation} {lang.prm.status.with}:{" "}
              <b>
                {about?.firstName || " - "} {about.lastName || " - "} ({" "}
                {about?.email} )
              </b>
            </>
          }
          size={"70%"}
        >
          <AnswerSender
            prospect={current}
            about={getProspectBio(current)}
            setAnswering={setOpened}
            setProspectLoading={onSent}
          />
        </Modal>
      )}
    </>
  );
};

export default EmailSenderModal;
